const converters = {
    data: () => ({
        invalidTime: '알 수 없는 시간'
    }),
    methods: {
        // receive firebase's serverTimestamp and convert it to Korean date format
        fromServerTimestampToDate(serverTimestamp) {
            if (!serverTimestamp) return this.invalidTime
            let date = new Date(1970, 0, 1)
            date.setSeconds(serverTimestamp.seconds)
            date = this.addHoursToDate(date, 9)
            return date.toLocaleString('ko-KR', {
                timeZone: 'Asia/Seoul',
                year: 'numeric',
                weekday: 'short',
                month: '2-digit',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        },
        addHoursToDate(date, hours) {
            return new Date(new Date(date).setHours(date.getHours() + hours));
        },
        // receive a number and convert it to Korean currency format
        convertNumberToMoneyFormat(number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }
    }
}

export default converters